module.exports = __webpack_public_path__ + "static/media/ico-ln.83ff33be.svg";